import { CountryEntity } from 'api/types/entity';
import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';
import {
  CountryRiskBadges,
  CountryRiskField,
} from 'modules/client/common/feature';
import {
  Field,
  useFormContext,
} from 'modules/client/legal/forms/companyRegistrationPlaceForm';

interface Props {
  countriesLoading?: boolean;
  countries: CountryEntity[];
}

export const CompanyRegistrationPlaceSection = ({
  countriesLoading,
  countries,
}: Props) => {
  const { t } = useTranslation();
  const { values } = useFormContext();

  return (
    <Section
      datax="companyRegistrationPlaceSection"
      title={t('client.legal.companyRegistrationPlace.title')}
    >
      <GridFields>
        <Field.Autocomplete
          fullWidth
          showRequiredMark
          label={t('client.legal.companyRegistrationPlace.county.label')}
          loading={countriesLoading}
          name="registrationPlace.country"
          optionLabelKey="name"
          options={countries}
          optionValueKey="id"
          placeholder={t(
            'client.legal.companyRegistrationPlace.county.placeholder'
          )}
          renderOptionRightAdornment={(option) => <CountryRiskBadges
            country={option as CountryEntity}
            field={CountryRiskField.CompanyRegistrationPlace}
          />}
          rightStartElement={
            <CountryRiskBadges
              country={values.registrationPlace?.country}
              field={CountryRiskField.CompanyRegistrationPlace}
            />
          }
        />

        <Field.Text
          fullWidth
          showRequiredMark
          label={t('client.legal.companyRegistrationPlace.locality.label')}
          name="registrationPlace.locality"
          placeholder={t(
            'client.legal.companyRegistrationPlace.locality.placeholder'
          )}
        />

        <Field.Text
          fullWidth
          label={t(
            'client.legal.companyRegistrationPlace.specialRegistrationArea.label'
          )}
          name="registrationPlace.specialRegistrationArea"
          placeholder={t(
            'client.legal.companyRegistrationPlace.specialRegistrationArea.placeholder'
          )}
        />
      </GridFields>
    </Section>
  );
};
